import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const bell: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <>
      <path
        id="Path_7136"
        data-name="Path 7136"
        d="M19.844,20.6h5.384l-1.513-1.465a2.091,2.091,0,0,1-.641-1.5v-3.3a6.283,6.283,0,0,0-4.307-5.9V8.086a2.155,2.155,0,0,0-4.307,0V8.44a6.283,6.283,0,0,0-4.307,5.9v3.3a2.091,2.091,0,0,1-.641,1.5L8,20.6h5.384m6.46,0v1.043a3.232,3.232,0,0,1-6.46,0V20.6m6.46,0h-6.46"
        transform="translate(-2.614 -1.386)"
        fill="none"
        stroke="#79cdd0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path id="Path_7137" data-name="Path 7137" d="M0,0H28V28H0Z" fill="none" />
    </>
  ),
};
